import React from 'react'

const BrandIcon = ({ size = 20, color = "#406212", ...props }) => {
  return (
    <svg 
      width={size} 
      height={size + 1} 
      viewBox="0 0 20 21" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      {...props}
    >
      <path 
        d="M9.21875 9.16138C9.21875 6.78828 11.1425 4.8645 13.5156 4.8645C15.8887 4.8645 17.8125 6.78828 17.8125 9.16138C17.8125 11.5345 15.8887 13.4583 13.5156 13.4583C11.1425 13.4583 9.21875 11.5345 9.21875 9.16138Z" 
        stroke={color} 
        strokeWidth="1.5"
      />
      <path 
        d="M13.5156 16.5833V13.4583M13.5156 16.5833H15.8594M13.5156 16.5833H11.1719" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M2.1875 9.552V8.96606C1.8639 8.96606 1.60156 9.22841 1.60156 9.552H2.1875ZM6.875 9.552H7.46094C7.46094 9.22841 7.1986 8.96606 6.875 8.96606V9.552ZM2.1875 10.1379H6.875V8.96606H2.1875V10.1379ZM6.28906 9.552V14.2395H7.46094V9.552H6.28906ZM2.77344 14.2395V9.552H1.60156V14.2395H2.77344ZM4.53125 15.9973C3.56044 15.9973 2.77344 15.2103 2.77344 14.2395H1.60156C1.60156 15.8575 2.91323 17.1692 4.53125 17.1692V15.9973ZM6.28906 14.2395C6.28906 15.2103 5.50206 15.9973 4.53125 15.9973V17.1692C6.14927 17.1692 7.46094 15.8575 7.46094 14.2395H6.28906Z" 
        fill={color}
      />
      <path 
        d="M2.96875 9.5519H6.09375V5.3472C6.09375 4.76644 5.48257 4.3887 4.96312 4.64843L3.40062 5.42968C3.13594 5.56201 2.96875 5.83254 2.96875 6.12845V9.5519Z" 
        stroke={color} 
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default BrandIcon
